<template src="./index.html"></template>
<script>
import { URL, apiCall } from "@/utils/api";

import { resolve } from "q";

import mixin from "@/mixins/index";

import TodayProblems from "@/components/partials/TodayProblems/index";
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import CitizenRequestsTable from "@/components/partials/CitizenRequestsTable/index";

const menus = [
  {
    key: "NEW",
    icon: "plus",
    title: "Yeni şikayət",
    hasCount: false,
    count: "",
  },
  {
    key: "APPEAL",
    icon: "diff",
    title: "Mobil müraciətlər",
    hasCount: true,
    count: "newCount",
  },
  /*  {
    key: 'OFFER',
    icon: 'diff',
    title: 'Mobil təkliflər',
    hasCount: true,
    count: 'offerCount'
  }, */
  {
    key: "TODAY",
    icon: "appstore",
    title: "Bugün baxılanlar",
    hasCount: true,
    count: "todayAddedCount",
  },
  {
    key: "ALL",
    icon: "appstore",
    title: "Bütün baxılanlar",
    hasCount: true,
    count: "allCount",
  },
];

export default {
  name: "Complaints",
  mixins: [mixin],
  components: {
    "today-problems": TodayProblems,
    "detail-modal": DetailModal,
    "citizen-requests": CitizenRequestsTable,
  },
  data() {
    return {
      oldDetPagination: { pageSize: 10, current: 1 },
      todayPagination: { pageSize: 10, current: 1 },
      menus,
      citizenRequests: [],
      data: [],
      counts: {},
      customValidator: {
        phoneError: null,
        hphoneError: null,
        wphoneError: null,
      },
      sameNumber: false,
      pagination: {},
      action: null,
      mylocale: { emptyText: "Məlumat yoxdur" },
      usersList: [],
      selectionModalVis: false,
      similarDetIds: [],
      prevProblem: null,
      comlisType: "TABLE",
      sameAddress: false,
      todayProblems: [],
      detailModalVis: false,
      problem: null,
      loading: false,
      simpagination: { pageSize: 10, current: 1 },
      curKey: null,
    };
  },
  computed: {
    mobilePrefixes() {
      return this.prefixes.filter((item) => item.indexOf("12") === -1);
    },
  },
  watch: {
    cuser: function (newVal) {
      if (!newVal) {
        this.oldDetails = [];
      } else if (
        newVal.mobilePhoneNumber &&
        newVal.mobilePhoneNumber === newVal.whatsapNumber &&
        newVal.prefix === newVal.wprefix
      ) {
        this.sameNumber = true;
      }
    },
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    getDetailed(record) {
      this.problem = record;
      this.detailModalVis = true;
    },
    handleModalClose() {
      this.detailModalVis = false;
      this.problem = null;
    },
    handleCheked(e) {
      this.sameAddress = e.target.checked;
      if (this.sameAddress) {
        this.cuser.address = this.cuser.registrationAddress;
      } else this.cuser.address = null;
    },
    handleNumCheked(e) {
      this.sameNumber = e.target.checked;
      if (this.sameNumber) {
        this.cuser.wphoneNumber = this.cuser.phoneNumber;
        this.cuser.wprefix = this.cuser.prefix;
      } else {
        this.cuser.wphoneNumber = null;
        this.cuser.wprefix = null;
      }
    },
    handleMenuChange(e) {
      localStorage.setItem("omis", e.key);
      this.curKey = e.key;
      if (e.key === "ALL") {
        this.getComplaints();
      } else if (e.key === "TODAY") {
        this.getTodayComplaints();
      } else if (e.key === "OFFER") {
        this.getCitizenRequests({ isOffer: true, sorter: null });
      } else if (e.key === "APPEAL") {
        this.getCitizenRequests({ isOffer: false, sorter: null });
      }
      if (e.key !== "NEW") {
        this.clear();
      }
    },
    getTodayComplaints() {
      this.loading = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "operator/todayProblems",
        params: {
          limit: this.todayPagination.pageSize,
          offset:
            this.todayPagination.pageSize * (this.todayPagination.current - 1),
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.todayProblems = response.data.data.entities;
          } else this.$message.error(response.data.error.message);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handlePhoneKeyDown(e) {
      if (isNaN(Number(e.key))) e.preventDefault();
    },
    handlePrefixChange(key) {
      if (this.sameNumber) {
        this.cuser.wprefix = key;
      }
    },
    handleNumberChange(val) {
      if (this.sameNumber) {
        this.cuser.wphoneNumber = this.cuser.phoneNumber;
      }
    },

    handleCRTChange({ pagination, filters, sorter }) {
      this.getCitizenRequests({
        isOffer: this.curKey === "OFFER",
        sorter: sorter,
      });
    },
    getCitizenRequests({ isOffer, sorter, isClear }) {
      this.loading = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "operator/crequests",
        params: {
          isClear: isClear,
          isOffer: isOffer,
          limit: 20,
          offset: this.$refs.citRequestsTable
            ? this.$refs.citRequestsTable.pagination.current *
                this.$refs.citRequestsTable.pagination.pageSize -
              this.$refs.citRequestsTable.pagination.pageSize
            : 0,
          sort_by:
            sorter && sorter.field
              ? sorter.field + "_" + sorter.order.replace("end", "")
              : undefined,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.citizenRequests = response.data.data.entities;
            const pagination = { ...this.$refs.citRequestsTable.pagination };
            pagination.total = response.data.data.totalCount;
            this.$refs.citRequestsTable.pagination = pagination;
          } else this.$message.error(response.data.error.message);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    chooseDetail(detail) {
      if (this.current == 1) {
        this.clearSelectedDetail();
        detail.streetKey = detail.str;
        this.selectedDetail = detail;
        this.similarDetIds.push(detail.id);
        this.similarDetails = this.similarDetailsAll.filter(
          (item) => this.similarDetIds.indexOf(item.id) == -1
        );
      }
    },

    onSelectModalClose() {
      this.selectionModalVis = false;
    },
    handleSelectionChange(user) {
      this.selectionModalVis = false;
      this.cuser = user;
      this.getOldAppeals();
      this.selUser = user;
    },
    onListChange(data) {
      this.appeal.details = data;
      this.similarDetIds = this.appeal.details.map((item) => item.id);
    },
    handleEdit(detail) {
      this.selectedDetail = detail;
    },
    resetAppeal() {
      this.appeal = {
        citizen: null,
        details: [],
        note: null,
      };
    },
    showConfirm(sendData) {
      const datas = sendData;
      const message = this.$message;
      const clearFunc = this.clear;
      this.$confirm({
        title: "Əlavə edilsin?  ",
        //content: "",
        okText: "Bəli ",
        okType: "primary",
        cancelText: "Xeyr",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url: URL[process.env.NODE_ENV].service_api + "appeals",
              method: "POST",
              data: datas,
            })
              .then((response) => {
                if (!response.data.error) {
                  message.success("Şikayət əlavə olundu");
                  clearFunc();
                  resolve();
                } else {
                  message.error(response.data.error.message);
                }
              })
              .catch((err) => {
                // destroyAll();
              });
          }).catch();
        },
        onCancel() {
         
        },
      });
    },
    getCounts() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "operator/counts",
      }).then((response) => {
        if (!response.data.error) this.counts = response.data.data;
        else this.$message.error(response.data.error.message);
      });
    },
    getComplaints() {
      this.loading = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "problems",
        method: "GET",
        params: {
          all: true,
          menu: "all",
          limit: 10,
          offset: 0,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.data = response.data.data.entities;
            const pagination = { ...this.pagination };
            pagination.total = response.data.data.totalCount;
            this.pagination = pagination;
          } else {
            this.$message.error(response.data.error.message);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("Xəta baş verdi");
        
        });
    },
    clear() {
      this.resetAppeal();
      this.current = 0;
      this.cuser = null;
      this.sameAddress = false;
      this.sameNumber = false;
      this.oldDetails = [];
      this.similarDetails = [];
      this.similarDetIds = [];
      this.clearSearch = true;
      if (this.$refs.usersearch) this.$refs.usersearch.reset();
      this.getCounts();
    },
    setPrevProblem(p) {
      if (this.$refs.problemform.tmpDetail.id) {
        this.clearSelectedDetail();
        this.$refs.problemform.resetTmpDetail();
      }
      this.$refs.problemform.setPrevProblem(p);
    },
  },
  async created() {
    this.getCounts();
    const currentTab = localStorage.getItem("omis");
    if (currentTab == "ALL") {
      this.currentTab = [currentTab];
      this.getComplaints();
    } else this.currentTab = ["NEW"];
  },
};
</script>

<style lang="scss" src="./index.scss"></style>
